<template>
  <feature-config-container />
</template>

<script>
  import { FeatureConfigContainer } from '@/modules/feature-config'

  export default {
    components: {
      FeatureConfigContainer,
    },
  }
</script>
